import { render, staticRenderFns } from "./Challenges_panel.vue?vue&type=template&id=56654283&"
import script from "./Challenges_panel.vue?vue&type=script&lang=js&"
export * from "./Challenges_panel.vue?vue&type=script&lang=js&"
import style0 from "./Challenges_panel.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Challenges_panel.vue"
export default component.exports